import {openLoginDialog} from '../actions/openLoginAction'
export const setOpenLoginDialog=(_isOpen:boolean)=>async(dispatch)=>{
        dispatch(openLoginDialog(_isOpen))


}